import { render } from "./pmanage.vue?vue&type=template&id=e8110034&scoped=true"
const script = {}

import "./pmanage.vue?vue&type=style&index=0&id=e8110034&lang=scss&scoped=true"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8110034"]])

export default __exports__